import React, { useState } from 'react';

import { DownOutlined } from '@ant-design/icons';
import { Alert as AntdAlert } from 'antd';
import classNames from 'classnames';

import { markdownToSafeInnerHTML } from 'utils/markdownUtils';

import { CollapsableInformationBannerProps } from './types';

import './index.less';

function CollapsableInformationBanner({
  message,
  description,
  closable,
  onClose,
  alertType,
  initialCollapseDescription,
}: CollapsableInformationBannerProps<string>): React.ReactElement {
  const [collapseDescription, setCollapseDescription] = useState(
    initialCollapseDescription,
  );

  const toggleCollapseDescription: React.MouseEventHandler<
    HTMLDivElement
  > = e => {
    // Prevent collapse when clicking on link
    if (e.target instanceof HTMLElement && e.target.tagName !== 'A') {
      setCollapseDescription(prev => !prev);
    }
  };

  return (
    <AntdAlert
      className="collapsableInformationBanner"
      message={message}
      description={
        collapseDescription ? null : (
          <div {...markdownToSafeInnerHTML(description, true)} />
        )
      }
      type={alertType}
      showIcon
      closable={closable ?? false}
      onClose={onClose}
      onClick={toggleCollapseDescription}
      action={
        <DownOutlined
          className={classNames('collapsableInformationBanner__icon', {
            'icon--rotated': !collapseDescription,
          })}
        />
      }
    />
  );
}

export default CollapsableInformationBanner;
